import React from 'react';
import b_ from 'b_';
import './ceSeparator.less';

const b = b_.with('ce-separator');

export const CESeparator = () => <div className={b()} />;
